import { useEffect, useState } from "react";
import { getAllAuthTagList } from "../services/authTagService";

interface IUseFetchAllAuthTags {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  enabled?: boolean;
}

const useFetchAllAuthTagsList = ({
  setIsLoading,
  enabled = true,
}: IUseFetchAllAuthTags) => {
  const [authAllTagsData, setAuthAllTagsData] = useState<any>({});

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await getAllAuthTagList();
      setAuthAllTagsData(result);
    } catch (err) {
      setAuthAllTagsData({});
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!enabled) {
      setAuthAllTagsData({});
      return;
    }
    fetchData();
  }, [enabled]);

  return [authAllTagsData, fetchData];
};

export default useFetchAllAuthTagsList;
